import { Component } from '@angular/core';
import { StatsCardsComponent } from '../../components/dashboard-components/stats-cards/stats-cards.component';
import { ChatBoxCardComponent } from '../../components/dashboard-components/chat-box-card/chat-box-card.component';
import { TopStudentCardComponent } from '../../components/dashboard-components/top-student-card/top-student-card.component';
import { CalenderCardComponent } from '../../components/dashboard-components/calender-card/calender-card.component';
import { ClassroomSyllabusCardComponent } from '../../components/dashboard-components/classroom-syllabus-card/classroom-syllabus-card.component';
import { PlatformUseageCardComponent } from '../../components/dashboard-components/platform-useage-card/platform-useage-card.component';
import { FilterBaseAccessService } from '../../auth/filterbase-access';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    StatsCardsComponent,
    ChatBoxCardComponent,
    TopStudentCardComponent,
    CalenderCardComponent,
    ClassroomSyllabusCardComponent,
    PlatformUseageCardComponent,
    CommonModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  dashboard_filter: boolean = false;
  stats:boolean = false;
  communication:boolean = false;
  communication_filter:boolean = false;
  top_student:boolean = false;
  top_student_filter:boolean = false;
  platform_usage:boolean = false;
  platform_usage_filter:boolean = false;
  calender:boolean = false;
  classroom_syllbus:boolean = false;
  classroom_syllbus_filter:boolean = false;
  
  constructor(private access: FilterBaseAccessService) {
    this.dashboard_filter =
      this.access.checkaccessforfiltersandactions('dashboard filter');
    this.stats =
      this.access.checkaccessforfiltersandactions('stats');
    this.communication =
      this.access.checkaccessforfiltersandactions('communication');
    this.communication_filter =
      this.access.checkaccessforfiltersandactions('communication filter');
    this.top_student =
      this.access.checkaccessforfiltersandactions('top student');
    this.top_student_filter =
      this.access.checkaccessforfiltersandactions('top student filter');
    this.platform_usage =
      this.access.checkaccessforfiltersandactions('platform usage');
    this.platform_usage_filter =
      this.access.checkaccessforfiltersandactions('platform usage filter');
    this.calender =
      this.access.checkaccessforfiltersandactions('calender');
    this.classroom_syllbus =
      this.access.checkaccessforfiltersandactions('classroom syllbus');
    this.classroom_syllbus_filter =
      this.access.checkaccessforfiltersandactions('classroom syllbus filter');
  }

}
